import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import React from 'react';
import PropTypes from 'prop-types';

const StyledGrid = styled(Grid)(({ theme }) => ({
  '& > div': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    position: 'relative',
    padding: theme.spacing(3),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(2),
    background: theme.palette.background.default,
    boxShadow: `0 0 20px 10px ${theme.palette.divider}`,
    cursor: 'default',
    overflow: 'hidden',
    transition: 'box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out',
    '&:hover': {
      boxShadow: `0 0 20px 10px ${theme.palette.background.brand}`,
      transform: 'scale(1.02)',
    },
    '& > *': {
      position: 'relative',
      zIndex: 1,
    },
    '.icon': {
      position: 'absolute',
      top: 0,
      left: 0,
      fontSize: '40rem',
      transform: 'rotate(15deg)',
      zIndex: 0,
      color: theme.palette.brand.extralight,
      '&.offset': {
        left: 'auto',
        right: '15%',
      },
    },
    '.title': {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(2),
      fontWeight: 'bold',
      // fontSize: '1vw',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    [theme.breakpoints.up('md')]: {
      '.title': {
        fontSize: '1.5vw',
      },
      '.icon': {
        '&.offset': {
          top: '-30%',
          left: '15%',
          right: 'auto',
        },
      },
    },
  },
}));

const PageGrid = ({ children = null, ...props }) => {
  return (
    <StyledGrid {...props}>
      {children}
    </StyledGrid>
  );
};

PageGrid.propTypes = {
  children: PropTypes.node,
};

export default PageGrid;
